import { SET_OPERATION_PROPERTY, SET_PATCH_OPERATION_FIELD } from 'store/actions/operation';

export default {
  [SET_OPERATION_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_OPERATION_PROPERTY, {
      field,
      value
    }),

  [SET_PATCH_OPERATION_FIELD]: ({ commit }, { field, value }) =>
    commit(SET_PATCH_OPERATION_FIELD, {
      field,
      value
    })
};
